import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

import { Metamodel } from 'app/model/base/model';
import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { InformixCopySource } from 'app/model/pipeline/copysource/informix.copysource';
import { InformixCopySink } from 'app/model/pipeline/copysink/informix.copysink';
import { getOdbcLinkedServiceConfigControls } from './odbc-metadata';
import { GlobalVariables } from 'app/services/globals';
import { DataSourceOptionKind, CommonResourceKind } from '@powerquery/mashup-editor-client';


export const informixMetadata: ILinkedServiceTypeMetadata = {
    type: adfModelTypeMap.informix.linkedServiceType,
    displayName: stringResources.Informix_DisplayText,
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-ibm'
    },
    isOnPremises: true,
    isFirstClass: true,
    supportedInTrident: GlobalVariables.enableOPDG,
    supportAutoFillCopilotInput: GlobalVariables.enableOPDG,
    isKnownInPipelineContext: GlobalVariables.enableOPDG,
    supportCopyJobSource: GlobalVariables.enableOPDG,
    supportCopyJobSink: GlobalVariables.enableOPDG,
    supportMultipleIncrementalColumns: true,
    pqoDataSourceOption: {
        kind: DataSourceOptionKind.Extension,
        resourceKind: 'InformixForPipeline' as CommonResourceKind
    },
    supportOPDG: GlobalVariables.enableOPDG,
    opdgOnly: true,
    supportFirstClassParameterExperience: true,
    supportDatasetV2: true,
    tableColumnNameQuotes: ['"', '"'],
    supportPreCopyScript: true,
    category: ['Database'],
    copySourceTypes: [Metamodel.modelFor(InformixCopySource).name],
    copySinkTypes: [Metamodel.modelFor(InformixCopySink).name],
    controls: getOdbcLinkedServiceConfigControls()
};
